import { Heading, HStack } from "@chakra-ui/react";
import React, { ReactElement, ReactNode } from "react";
import { FaChevronLeft } from "react-icons/fa";
import InspectorButton from "./InspectorButton";

export interface InspectorTitleProps {
  children: ReactNode;
  backLabel?: string;
  onBackClick?: () => void;
}

export default function InspectorTitle(
  props: InspectorTitleProps
): ReactElement {
  const { children, backLabel, onBackClick } = props;

  const backButton =
    onBackClick == null ? null : (
      <InspectorButton
        as={FaChevronLeft}
        ariaLabel={backLabel ?? "Back"}
        onClick={evt => {
          evt.stopPropagation();
          onBackClick();
        }}
      />
    );

  const heading = <Heading size="md">{children}</Heading>;

  return (
    <HStack px="2" pt="4">
      {backButton} {heading}
    </HStack>
  );
}
